# import PlaidFragment from "../fragments/plaid-balance.graphql"

query PlaidCashBalancesQuery($company_id: ID!) {
  plaidCashBalances(company_id: $company_id) {
    ...PlaidFragment
  }
}
